import {FeatureMap} from '@/components/featureMap/featureMap';
import {Typography} from '@/components/ui/typography';
import {FC} from 'react';
import {EventRoute} from '../eventRoutes';

interface RouteMapProps {
  /**
   * Whether the track data is loading
   */
  loading: boolean;
  /**
   * Whether loading the tracks encountered an error
   */
  error: boolean;
  /**
   * The route to render on the map
   */
  route?: EventRoute;
}

export const RouteMap: FC<RouteMapProps> = ({loading, error, route}) => {
  const hasTrack = route && route.track_points && route.track_points.length > 0;

  const mapVisible = hasTrack && !error && !loading;

  if (!error && !loading && !hasTrack) return null;

  return (
    <div className="rounded-lg h-80 overflow-hidden bg-gray-100 flex items-center justify-center">
      {loading && (
        <div className="flex flex-col items-center gap-2 text-gray-400">
          <div className="w-6 h-6 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin" />
          <Typography level="B2" className="text-neutral-400">
            Loading map...
          </Typography>
        </div>
      )}
      {error && (
        <Typography level="B2" className="text-gray-400">
          Unable to load map
        </Typography>
      )}
      {mapVisible && <FeatureMap route={route} />}
    </div>
  );
};
